import { RouteObject } from "react-router";
import UserGuard from "routes/guards/user";
import UserListProvider from "providers/user-list";
import UserFinishedView from "views/user/finished/view";
import UserInvitationSignicatAbortView from "views/user/invitation/signicat/abort";
import UserInvitationSignicatErrorView from "views/user/invitation/signicat/error";
import UserInvitationSignicatSuccessView from "views/user/invitation/signicat/success";
import UserInvitationView from "views/user/invitation/view";
import UserListEntityView from "views/user/list-entity/view";
import UserListObligationView from "views/user/list-obligation/view";
import UserListSummaryView from "views/user/list-summary/view";
import UserLoginSignicatAbortView from "views/user/list/login/signicat/abort";
import UserLoginSignicatErrorView from "views/user/list/login/signicat/error";
import UserLoginSignicatSuccessView from "views/user/list/login/signicat/success";
import UserListLoginView from "views/user/list/login/view";
import UserListView from "views/user/list/view";
import UserLogoutView from "views/user/logout/view";

export const userRoutes: RouteObject[] = [
  {
    // start with nested routing
    path: "user",
    children: [
      // non-guarded routes
      { path: "logout", element: <UserLogoutView /> },
      { path: "finished", element: <UserFinishedView /> }, // after has finished

      // non-guarded, invitation routers
      {
        path: "invitation/:invitationUuid",
        children: [
          {
            index: true,
            element: <UserInvitationView />,
          },
          {
            path: "signicat",
            children: [
              {
                path: "success",
                element: <UserInvitationSignicatSuccessView />,
              },
              {
                path: "abort",
                element: <UserInvitationSignicatAbortView />,
              },
              {
                path: "error",
                element: <UserInvitationSignicatErrorView />,
              },
            ],
          },
        ],
      },

      // non-guarded, login routes
      {
        path: "list/:listUuid/login",
        children: [
          { index: true, element: <UserListLoginView /> },
          {
            path: "signicat",
            children: [
              {
                path: "success",
                element: <UserLoginSignicatSuccessView />,
              },
              {
                path: "abort",
                element: <UserLoginSignicatAbortView />,
              },
              {
                path: "error",
                element: <UserLoginSignicatErrorView />,
              },
            ],
          },
        ],
      },

      // guarded routes
      {
        element: <UserGuard />,
        children: [
          {
            path: "list/:listUuid",
            element: <UserListProvider />,
            children: [
              { index: true, element: <UserListView /> },
              {
                path: "obligation",
                element: <UserListObligationView />,
              },
              {
                path: "entity/:entityUuid",
                element: <UserListEntityView />,
              },
              {
                path: "summary",
                element: <UserListSummaryView />,
              },
            ],
          },
        ],
      },
    ],
  },
];
